module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-kids-5b30c10c318d5dc6e261c7912b959c42.webp";